import React, { ReactElement, useEffect } from 'react';
import { ITopicFilterState } from 'components/TopicFilters/shared';
import styled, { css } from 'styled-components/macro';
import TopicFilterCustomerDropdown from 'components/base/TopicFiltersDropdown/CustomerDropdown';
import { Button } from 'components/TopicFilters/TopicFilters.styles';
import { ReactComponent as IconClearFilter } from 'icons/icon-clear-filter.svg';
import Span from 'components/elements/span';
import Box from 'components/elements/Box';
import colors from 'styles/themes/colors';
import usePlatforms from 'hooks/usePlatforms';
import PlatformIcon from './PlatformIcon';

import { ListItemBoxBase } from 'components/base/Dropdown/shared/styles';

const ListWrapper = styled(Box)<any>`
  ${ListItemBoxBase}
  padding: ${({ theme }): string => `0.7rem ${theme.spacing.large}`};

  &:hover,
  &[aria-selected='true'] {
    background: ${colors.Sand};
  }

  ${({ isActive }): any => css`
    cursor: pointer;
    background: ${isActive ? colors.Sand : 'white'};
  `}
`;

const ListLabelSpan = styled('span')`
  display: block;
  margin-left: 12px;
  font-size: 12px;
  line-height: 41px;
  letter-spacing: 0.5px;
  color: #8ea6be;
`;

const ListItem: React.FC<any> = (props) => {
  const { item, isActive } = props;
  return (
    <ListWrapper
      isActive={isActive}
      display="flex"
      alignItems="flex-start"
      justifyContent="flex-start"
      alignContent="stretch"
      py={2}
      paddingRight={2}
      paddingLeft={3}
      minWidth="270px"
    >
      <Box
        alignSelf="center"
        display="inline-block"
        minWidth="1.8rem"
        maxHeight="18px"
      >
        <PlatformIcon icon={item.icon} platformName={item.name} />
      </Box>
      <Span marginLeft={1} alignSelf="auto">
        {item.label}
      </Span>
    </ListWrapper>
  );
};

interface IPlatformFilterContainerProps {
  setFilter: any;
  clearFilterUrl: any;
  filters: ITopicFilterState;
}

const PlatformFilterContainer: React.FC<IPlatformFilterContainerProps> = (
  props
) => {
  const { setFilter, clearFilterUrl, filters } = props;
  const {
    platformsList: items,
    selectedPlatform: selectedItem,
    isPlatformLoaded,
  } = usePlatforms(filters);

  const onChange = (item: any): void => setFilter('platform', item?.id);

  useEffect(() => {
    // clear platform filter if platform doesn't come from backend
    if (isPlatformLoaded && !selectedItem && filters.platform) {
      clearFilterUrl('platform');
    }
  }, [isPlatformLoaded, selectedItem]);

  const ListLabel = (): ReactElement => (
    <ListLabelSpan>{`SELECT PLATFORM:`}</ListLabelSpan>
  );

  return (
    <TopicFilterCustomerDropdown
      onChange={onChange}
      items={items}
      selectedItem={selectedItem}
      defaultLabel="All"
      ListLabel={ListLabel}
      customItem={ListItem}
      itemToString={(item): any => `${item?.id}-${item?.label}`}
      clearFilter={(): void => clearFilterUrl('platform')}
      customLabel="Platform"
    >
      <Button
        borderColor={'LightGrey'}
        borderWidth={'1px'}
        borderStyle={'solid'}
        py={4}
        isActive={!!selectedItem}
        onClick={(): void => clearFilterUrl('platform')}
        isClearButton
      >
        <IconClearFilter />
        Clear this filter
      </Button>
    </TopicFilterCustomerDropdown>
  );
};

export default PlatformFilterContainer;
